import {required, minValue, numeric} from 'vuelidate/lib/validators';
import {
    PaymentInstructionModel,
} from '@/common/models/rules/actions/schedule-payment-retry-action-model';

export default function getPaymentValidation(paymentInstruction) {
    const validation = {
        method: {
            required,
        },
    };
    // payment validations
    if (paymentInstruction.method !== PaymentInstructionModel.Methods.none) {
        validation.value = {
            required,
            numeric,
            minValue: minValue(1),
        };
        validation.type = {
            required,
        };
    }

    return validation;
}
